import { Box, CircularProgress } from '@mui/material';
import React from 'react';

const LoadingScreen = (): JSX.Element => {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <CircularProgress size={100} />
    </Box>
  );
};

export default LoadingScreen;
